import { get as getProjection } from 'ol/proj';
export function extract_wkid(projCode) {
    if (!projCode)
        return null;
    if (/^\d+$/.test(projCode)) {
        return parseInt(projCode, 10);
    }
    const match = projCode.match(/EPSG:(\d+)/i);
    if (match && match[1]) {
        return parseInt(match[1], 10);
    }
    return null;
}
export function declared_wkids(sr) {
    if (!sr)
        return [];
    return [sr.latestWkid, sr.wkid]
        .filter((wkid) => typeof wkid === 'number' && wkid > 0)
        .filter((wkid, index, all) => all.indexOf(wkid) === index);
}
export function first_registered_wkid(...candidates) {
    for (const candidate of candidates) {
        if (!candidate)
            continue;
        if (getProjection(`EPSG:${candidate}`))
            return candidate;
    }
    return null;
}
export function read_wkid(sr) {
    return first_registered_wkid(...declared_wkids(sr));
}
